import { useNavigate } from 'react-router';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';
import clsx from 'clsx';
import Button from '../../components/Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';

export default function BillingSuccesPage() {
  const navigate = useNavigate();
  const sizes = useButtonSizeLarge();

  return (
    <main className="relative z-10 flex w-full flex-1 flex-col items-center justify-between gap-10 pb-5">
      <div className="flex w-full flex-1 flex-col justify-center px-6">
        <div className="mx-auto flex max-w-766 flex-col items-center gap-12">
          <GreenCheckIcon className="h-100 w-100 lg:h-150 lg:w-150" />
          <div className="flex flex-col gap-2.5 text-center">
            <h2 className={clsx('font-semibold', 'text-brand-byzantine')}>
              Subscription Purchased
            </h2>
            <p
              className={clsx(
                'font-inter-variable text-lg font-medium italic md:text-2xl',
                'text-brand-byzantine',
              )}
            >
              Your subscription has been successfully purchased. You can now
              access all the features of EHS Navigator.
            </p>
          </div>
          <Button
            onClick={() => navigate('/dashboard')}
            otherClasses={clsx('max-w-465 w-full')}
            size={sizes}
          >
            Proceed to Dashboard
          </Button>
        </div>
      </div>
    </main>
  );
}
